(function ($) {
  Drupal.behaviors.mpp = {
    attach: function (context, settings) {
      var productsArray = page_data['catalog-mpp'].categories[0].products;

      $('.js-product-brief').each(function () {
        var productId = $(this).attr('data-product-id');
        var productData = _.find(productsArray, function (p) {
          return p.PRODUCT_ID == productId;
        });

        if (typeof site.product !== 'undefined' && typeof site.product.view !== 'undefined' && typeof site.product.view.brief !== 'undefined') {
          site.product.view.brief({
            containerNode: this,
            productData: productData
          });
        }
        // ie8 pie attach behavior
        if (generic.env.isIE8) {
          if (window.PIE) {
            $('.swatches--single div').each(function (i, el) {
	      PIE.attach(this);
            });
          }
        }
      });

      // adding tooltip to shade select button
      $('.product_brief__button-panel.button-color-picker').each(function () {
        $(this).hover(function () {
          // PHF 20150731 1645 i230637: on iPad, hover is a tap... so it takes two
          // taps to get to the color pallet.  THis condition gets us there in one.
          var isiPad = /ipad/i.test(navigator.userAgent.toLowerCase());

          if (!isiPad) {
            $(this).append('<div class="tooltip"><p>' + site.selectShade + '</p></div>');
          }
        }, function () {
          $('div.tooltip').remove();
        });
      });

      if (typeof site.product !== 'undefined' && typeof site.product.view !== 'undefined') {
        if (typeof site.product.view.miscFlagAlign !== 'undefined') {
          site.product.view.miscFlagAlign($('.mpp__product'));
        }
        if (typeof site.product.view.equalRowHeight !== 'undefined') {
          site.product.view.equalRowHeight($('.mpp__product'));
        }
      }
      $('.mpp__product-grid .mpp__product:nth-child(3n+2)').addClass('nth-child-3np2');

      // quickshop test
      function getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

        for (var i = 0; i < hashes.length; i++) {
          hash = hashes[i].split('=');
          vars.push(hash[0]);
          vars[hash[0]] = hash[1];
        }

        return vars;
      }
      var qs = getUrlVars()['qs'];

      if (qs) {
        $('.qs_test').removeClass('hidden');
        $('.qs_test').click(function (event) {
          var pid = $(this).attr('data-product-id');
          var quickshopData = _.find(productsArray, function (p) {
            return p.PRODUCT_ID == pid;
          });

          site.quickshop(quickshopData);
        });
      // $('.qs_test').eq(1).trigger('click');
      }

      // Procuct Sort
      site.productSort.init(productsArray);
      // Product compare nav
      site.mppCompareInit(productsArray);

      // Personalization MPP initialization
      if (Drupal.ELB.hasPersonalization()) {
        site.profile.pc.MPP(page_data['catalog-mpp']);
      }
    }
  };
})(jQuery);
